import { Link } from 'react-router-dom';

export const Work = () => {
  return (
    <section id="work" className="section work-jagged">
      <div className="section-head reveal">
        <div>
          <p className="section-eyebrow">01 — Selected work</p>
          <h2 className="section-title">Things I've shipped</h2>
        </div>
        <p className="section-note">Built, running, and still growing.</p>
      </div>
      <div className="work-grid">
        <article className="work-card work-card-flagship reveal">
          <div className="work-card-tags">
            <span className="tag tag-accent">Data</span>
            <span className="tag tag-neutral">Flagship</span>
          </div>
          <h3 className="work-card-title">Car Collection Dashboard</h3>
          <p className="work-card-body">
            An interactive dashboard for a car collection, served live from a
            GraphQL API on AWS AppSync, Lambda, and DynamoDB. It has a
            draggable board layout, a sortable table, and a chart of average
            top speed by category.
          </p>
          <Link className="work-card-link" to="/dashboard">
            Open Dashboard →
          </Link>
        </article>

        <article className="work-card work-card-secondary reveal">
          <div className="work-card-kicker">Mobile</div>
          <h3 className="work-card-title">iOS App</h3>
          <p className="work-card-body">
            Currently in the works. The download link goes live here once
            it ships.
          </p>
          <span className="btn btn-disabled" aria-disabled="true">
            Coming Soon
          </span>
        </article>
      </div>
    </section>
  );
};
